import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const DisclaimersBox = ({ disclaimers = [] }) => {
  if (!Array.isArray(disclaimers) || disclaimers.length === 0) return null;

  return (
    <Box
      sx={{
        mt: 4,
        p: 3,
        borderRadius: "16px",
        border: "1px solid #D1D1D1",
        backgroundColor: "#FAFAFA",
      }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
        <WarningAmberIcon sx={{ color: "#A5A5A5", mr: 1 }} />
        <Typography variant="h6" fontWeight="bold" sx={{ color: "#757575" }}>
          DISCLAIMERS
        </Typography>
      </Box>

      <Divider sx={{ mb: 2, borderColor: "#D1D1D1" }} />

      <Box component="ul" sx={{ pl: 3, m: 0 }}>
        {disclaimers.map((d, index) => (
          <li key={index}>
            <Typography
              variant="body2"
              sx={{ color: "#757575", mb: 1, listStyleType: "disc" }}>
              {typeof d === "string" ? d : d.text}
            </Typography>
          </li>
        ))}
      </Box>
    </Box>
  );
};

export default DisclaimersBox;
